import { Platform } from "react-native";
const isWeb = Platform.OS === "web";
const isAndroid = Platform.OS === "android";
const isIOS = Platform.OS === "ios";

export const getBrowserType = () => {
	if (!isWeb) {
		return "native";
	}

	const userAgent = navigator.userAgent;

	const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
	const isChromiumBased = /Chrome|Chromium|CriOS/i.test(userAgent) && !isSafari;

	if (isSafari) {
		return "safari";
	}
	if (isChromiumBased) {
		return "chromium";
	}
	return "other";
};

export const isSafari = getBrowserType() === "safari";
export const isChromium = getBrowserType() === "chromium";

export { isWeb, isAndroid, isIOS };
